<script setup>
import {
  pressCenterFilterTypesDataValues,
  pressCenterFilterDataValues,
} from '@/constants/press-center';

defineProps({
  files: {
    type: Array,
    default: undefined,
  },
});

const articlesStore = useArticlesStore();
const { t } = useI18n();

const { filterQuery, filterModels } = useQueryFilter(
  pressCenterFilterDataValues,
);
const filterQueryAdapted = computed(() => {
  const { type } = filterQuery.value;

  const typeValue =
    pressCenterFilterTypesDataValues.find(
      (typeData) => typeData.queryKey === type,
    )?.sendKey || null;

  return {
    type: typeValue,
  };
});

const filterOptions = computed(() => {
  const optionAll = {
    name: t('pressCenter.types.all'),
    id: null,
  };

  const options = pressCenterFilterTypesDataValues.map((typeData) => ({
    name: t(`pressCenter.types.${typeData.key}`),
    id: typeData.queryKey,
  }));

  return [optionAll, ...options];
});

const page = ref(1);

watch(filterQuery, () => {
  page.value = 1;
});

const limit = 12;
const offset = computed(() => (page.value - 1) * limit);

// articles
const { data: articlesData, pending: articlesPending } = await useAsyncData(
  () =>
    articlesStore.fetchArticles({
      filter: filterQueryAdapted.value,
      limit,
      offset: offset.value,
    }),
  { watch: [filterQuery, page] },
);

const pageCount = computed(() =>
  Math.ceil(articlesData.value.meta.total / limit),
);

function getLinkAttributes(article) {
  const { link } = article;

  return {
    to: link ? link : `/press-center/details/${article.id}`,
    target: link ? '_blank' : undefined,
  };
}

const rootRef = ref(null);
onMounted(() => {
  watch(articlesData, async () => {
    await awaitDoubleRAF();
    safeScrollToElement(rootRef.value.$el);
  });
});
</script>

<template>
  <BundlesList
    ref="rootRef"
    v-model:filter="filterModels.type"
    v-model:page="page"
    class="ctr-press-content"
    :title="$t('pressCenter.heading')"
    :filter-options="filterOptions"
    :files="files"
    :items="articlesData.articles"
    :items-pending="articlesPending"
    :get-link-attributes="getLinkAttributes"
    :page-count="pageCount"
    link-date-key="publishedAt"
  />
</template>
